import { Icon } from "@chakra-ui/react";
const LightUPArrow = () => {
  return (
    <>
      <Icon
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="17" cy="17" r="17" fill="#D2E4E8" />
        <circle cx="17" cy="17" r="10" fill="black" />
        <path d="M17 13L11.8038 19H22.1962L17 13Z" fill="#D2E4E8" />
      </Icon>
    </>
  );
};
export default LightUPArrow;
